import { createMemoryHistory, createBrowserHistory } from 'history';
import { toLocaleFromHostname } from '@core/internationalize/models/locale';
import { getLocaleBasePath } from '@core/internationalize/models/path';
import { LOCALE_TOGGLE } from '@core/internationalize/models/toggle';
import { isReactNative } from '@core/navigator/product';

export const createHistoryWithBaseName = () =>
  createBrowserHistory({ basename: getLocaleBasePath(toLocaleFromHostname()) });

const getBrowserHistory = () =>
  LOCALE_TOGGLE ? createHistoryWithBaseName() : createBrowserHistory();

export default isReactNative() || typeof window === 'undefined'
  ? createMemoryHistory()
  : getBrowserHistory();
